<template>
	<div class="service-modal" :style='containerStyle' @mousedown='mousedown' @mousemove='mousemove' @mouseup='mouseup' @mouseleave='mouseup'>
		<div :style='{width:style.width + "px",height:style.height + "px",position:style.position}' class="service-content">
    		<iframe :key='src' ref='serviceFrame' width="100%" height="100%" :src="src"></iframe>
    		<div class="mask" v-show='isResizing'></div>
    	</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	const availWidth = window.screen.availWidth
	const availHeight = window.screen.availHeight
	export default {
		data() {
			return {
				isResizing:false,
				curCoor:null,
				style:{
					width: availWidth <= 768 ? availWidth : 374,
					height:availWidth <= 768 ? availHeight:582,
					position:'relative'
				},
				containerStyle:{
				}
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		props:{
			src:{
				type:String,
				default:'',
			},
			visiable:{
				type:Boolean,
				default:false,
			}
		},
		mounted() {

		},
		watch:{
			visiable(value){
				if (value) {
					this.$refs.serviceFrame.contentWindow.postMessage({action:'showPanel'},'*')
				}
			}
		},
		mixins:[],
		components: {

		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				
			]),
			async initData(){
				if (this.visiable) {
					this.$refs.serviceFrame.contentWindow.postMessage({action:'showPanel'},'*')
				}
			},
			mousedown(e){
				this.isResizing = true
				this.containerStyle= {
					width:'100%',
					height:'100%'
				}
				this.style.position = 'absolute'
				let {x,y} = e
				this.curCoor = {x,y}
			},
			mousemove(e){
				if (!this.isResizing) return
				let {x,y} = e
				let width = e.x - this.curCoor.x + this.style.width
				let height = this.curCoor.y - e.y + this.style.height
				this.style = {width,height,position:'absolute'}
				this.curCoor = {x,y}
			},
			mouseup(){
				console.log('up or out')
				this.containerStyle= {}
				this.style.position = 'relative'
				this.isResizing = false
				this.curCoor = null
			},
		},
	}
</script>

<style lang='scss' scoped>
	.service-modal {
		// width:100%;
		position:fixed;
		left: 0px;
		bottom: 0px;
		padding-top: 10px;
		padding-right: 10px;
		// background-color: red;
		
		.service-content {
			position: relative;
			margin-right: 3px;
			margin-top: 3px;
			left: 0;
			bottom:0;
			min-width:374px;
			min-height:582px;
			background-color: #fff;
			box-shadow:-1px 12px 20px 0px rgba(0, 0, 0, 0.2);
		}
		.mask {
			position: absolute;
			width:100%;
			height:100%;
			top: 0;
			left: 0;
			background-color: rgba(0,0,0,0.1);
		}
		cursor: nesw-resize;
		
		iframe {
			border:none;
		}
	}
</style>